export const TIME_RANGE_CONTROL_LABELS = {
  REFRESH: 'Refresh',
  ZOOM_OUT: 'Zoom out',
  FORWARD: 'Forward',
  BACKWARD: 'Backward',
};
